import {css, view} from '@sail/ui';
import {MetaEventStyle} from '@stripe-internal/conversations-client';
import {useMemo} from 'react';
import {ChatRowContainer} from './ChatRowContainer';
import {
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
} from '../../FeatureFlagsProvider';

export type Props = {
  style?: MetaEventStyle;
  children: React.ReactNode;
};

export const MetaRow = ({style, children}: Props) => {
  const useNewDesign = useNewUniversalHelpDesign();
  const useDotComDesign = useUniversalHelpDotComDesign();

  const styles = useMemo(() => {
    if (useNewDesign) {
      if (style === 'body') {
        return css({
          textAlign: 'left',
          font: 'body.small',
          marginBottom: 'medium',
        });
      } else {
        return css({
          textAlign: 'center',
          font: 'label.small',
          textColor: 'subdued',
        });
      }
    }

    if (useDotComDesign) {
      return css({
        textAlign: 'center',
        font: 'label.small',
        textColor: 'subdued',
      });
    }

    return css({
      textAlign: 'center',
      font: 'label.small',
      fontStyle: 'italic',
      textColor: 'subdued',
    });
  }, [useNewDesign, useDotComDesign, style]);

  return (
    <view.div data-testid="meta-row">
      <ChatRowContainer position="center">
        <view.div uses={[styles]}>{children}</view.div>
      </ChatRowContainer>
    </view.div>
  );
};
